import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-benefits',
  templateUrl: './program-benefits.component.html',
  styleUrl: './program-benefits.component.less',
})
export class ProgramBenefitsComponent implements OnInit {

  @Input() landingCMSData: any;
  carouselOptions = {
    loop: true,           // Disable looping if needed
    nav: false,             // Show next/previous navigation buttons
    dots: false,            // Show dot indicators for carousel navigation
    autoplay: true,
    // autoHeight: true,
    autoWidth: true,
    responsive: {
      0: {
        items: 1           // Display 1 card on very small screens (mobile)
      },
      600: {
        items: 2           // Display 2 cards on medium screens (tablet)
      },
      1200: {
        items: 3.2          // Display 3 cards on large screens (desktop)
      }
    }
  };
  

  cardList: any = [];

  constructor() {
  }

  ngOnInit(): void {
    this.landingCMSData.loyaltyEcosystemBenefitsCards.forEach((element: any) => {
      this.cardList.push(element);
    });
  }

}
